import Report from './report'

const card = {
  report: Report
}

export default card
